
















































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import IArrow from '@/components/icons/IArrow.vue'
import ICheck from '@/components/icons/ICheckContactBlock.vue'
import {SERVER_HOST_QR} from "@/config";


@Component({
  components: {
    'i-arrow': IArrow,
    'i-check': ICheck,
  }
})
export default class SurveysShard extends Vue {
  @Prop({type: [Object], default: {}}) protected shard!: any
  @Prop({type: [Boolean], default: false}) protected loadShardStatus!: boolean

  surveys: any = []
  menuOpened: boolean = false
  server:string = SERVER_HOST_QR
  showMenu: boolean = false

  get currentSurveys() {
    let surveys = this.surveys.filter((survey:any) => survey.select)
    return !surveys.length ? [] : surveys[0].id == 'all' ? this.shard.surveyDataWeb : surveys
  }

  @Watch('shard')
  checkSurvey() {
    this.selectedSurveys()
  }

  @Watch('menuOpened')
  changeScroll() {
    this.$emit('changeStopScroll', this.menuOpened)
  }

  mounted() {
    this.selectedSurveys()
    let body = document.querySelector('body') as HTMLElement
    body.addEventListener('click', () => {
      this.showMenu = false
    })
  }

  selectedSurveys() {
    let surveys:any = [{id: 'all', text: this.$t('newShardList.surveys.selectAll'), select: false}]
    this.shard.surveyDataWeb.forEach((survey:any, index:any) => {
      surveys.push({...survey, id: index, text: survey.title, select: false})
      survey.id = index
    })
    this.surveys = surveys
  }

  clickSurvey(item:any) {
    if(item.id == 'all') {
      this.surveys.forEach((survey:any) => {
        survey.select = false
      })
      item.select = true
    } else {
      item.select = item.select ? false : true
      if(item.select) {
        this.surveys.find((survey:any) => survey.id == 'all').select = false
      }
    }
  }


}
